<template>
  <div class="gauge-bar" :title="tooltip()">
    <span v-for="index in indexes" :key="index"
          class="gauge-box"
          :class="{'gauge-box-fill': val >= index}">
    </span>
  </div>
</template>

<script>

export default {
  name: 'BarGauge',
  props: {
    size: { type: Number, required: true },
    val: { type: Number, required: true },
  },
  computed: {
    indexes() {
      const result = [];
      for (let i = 1; i <= this.size; i++) {
        result.push(i);
      }
      return result;
    },
  },
  methods: {
    tooltip() {
      const label = {
        1: 'Emerging',
        2: 'Significant',
        3: 'Market Leading',
      };
      return `${label[this.val]} Capability`;
    },
  },
};
</script>

<style scoped>
  .gauge-bar {
    white-space: nowrap;
  }
  .gauge-box {
    box-sizing: content-box;
    display: inline-block;
    width: 6px;
    height: 20px;
    border: 1px solid #9B99CB;
    border-radius: 2px;
    margin-right: 2px;
  }
  .gauge-box-fill {
    background-color: #9B99CB; /* purple */
  }
</style>
